import { inject, Injectable, signal } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { AppConfigState } from '../../shared/store/app-config.state';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VersioningService {
  readonly #http = new HttpClient(inject(HttpBackend));
  readonly #config = inject(AppConfigState);

  readonly #version = signal('undetected');
  readonly version = this.#version.asReadonly();

  public loadVersion(): Observable<string> {
    return this.#http.get<{ version: string }>(`${this.#config.apiPath}/health`).pipe(
      map((response) => response.version),
      catchError(() => of('undetected')),
      tap((version) => this.#version.set(version)),
    );
  }
}
